/**
 * OTP (One-Time Password) related constants
 */

/** OTP validity duration in seconds (30 minutes) */
export const OTP_VALIDITY_SECONDS = 30 * 60;

/** Cooldown duration before allowing resend in seconds (1 minute) */
export const RESEND_COOLDOWN_SECONDS = 60;
